import { Component, Input } from '@angular/core';
import { SubSectionComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-subsection',
  templateUrl: './app-subsection.component.html',
})

export class AppSubSectionComponent extends SubSectionComponent {
  @Input() layout = 'inline';
  @Input() showHeader = false;
}
